import React from 'react'
import {Link} from 'react-router'
import sortBy from 'lodash/sortBy'
import moment from 'moment'
import DocumentTitle from 'react-document-title'
import {prefixLink} from 'gatsby-helpers'
import access from 'safe-access'
import {config} from 'config'
import SitePost from '../components/SitePost'

class SiteIndex extends React.Component {
  description(body) {
    var test = body.replace(/<blockquote>/g, '<blockquote class="blockquote">')
    if (test.match("<!--more-->")) {
      test = test.split("<!--more-->")
      if (typeof test[0] != "undefined") {
        return test[0]
      }
    }
    return test
  }

  getDescptionImage(page) {
    let image = access(page, 'data.image')
    let dir = access(page, 'file.dir')
    if (image !== undefined){
      return <img src={`${dir}/${image}`} />
    }

    // image is not defined explicitly in the header data of the article,
    // try to get the first image of the article instead if exists
    const body = access(page, 'data.body')
    // console.debug(body)
    let result = /<img src=".\/([^ "]+)"/.exec(body)
    image = result && result[1]

    if (image) {
      return <img src={`${dir}/${image}`} />
    }

    // there is no image in the article, return null as a node
    return null
  }


  render() {
    const pageLinks = []

    // Sort pages.
    const sortedPages = sortBy(this.props.route.pages, (page) => access(page, 'data.date')
    ).reverse()
    sortedPages.forEach((page) => {
      if (access(page, 'file.ext') === 'md' && access(page, 'data.layout') === 'post') {
        const title = access(page, 'data.title') || page.path
        const description = access(page, 'data.description') || access(page, 'data.body')
        const datePublished = access(page, 'data.date')
        const categories = access(page, 'data.categories')
        // const image = access(page, 'data.image')

        // const imagePath = `${access(page, 'file.dir')}/${image}`

        const category = []
        for (const i in categories) {
          const c = categories[i]
          category.push(
            <span className="tag tag-danger" key={i}>{ c }</span>
          )
        }

        const data = {}

        pageLinks.push(
          <div className='article-wrap' key={page.path}>
            <div className="page-header">
              <Link style={ {textDecoration: 'none',} } to={ prefixLink(page.path) }>
                <h1>{ title }</h1>
                <time dateTime={ moment(datePublished).format('MMMM D, YYYY') }>
                  { moment(datePublished).format('YYYY/MM/DD') }
                </time>
              </Link>
              { category }
            </div>
            {this.getDescptionImage(page)}
            {/*<div className="page-content" dangerouslySetInnerHTML={ {__html: this.description(description)} }/>*/}
            <p><Link className='readmore' to={ prefixLink(page.path) }><span
              className="btn btn-outline-danger btn-block">阅读全文</span></Link></p>
          </div>
        )
      }
    })

    return (
      <DocumentTitle title={ config.siteTitle }>
        <div className='container'>
          <div className='articles col-md-12'>
            { pageLinks }
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

SiteIndex.propTypes = {
  route: React.PropTypes.object,
}

export default SiteIndex



// WEBPACK FOOTER //
// ./index.jsx